import { render, staticRenderFns } from "./DetalleVentaCartera.vue?vue&type=template&id=320e3d37"
import script from "./DetalleVentaCartera.vue?vue&type=script&lang=js"
export * from "./DetalleVentaCartera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports